query AutomationGraphRules($kind: AutomationKind!) {
  automationGraphRules(kind: $kind) {
    kind
    templates {
      key
      trigger
    }
  }
}
